"use client";

import { c as _c } from "react/compiler-runtime";
import AutoHeight from "embla-carousel-auto-height";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, useCarousel } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import AdministrationSection from "./industries/administration-section";
import GovernmentSection from "./industries/government-section";
import LogisticsSection from "./industries/logistics-section";
import ManufacturingSection from "./industries/manufacturing-section";
import MoreIndustriesSection from "./industries/more-industries-section";
import SportsSection from "./industries/sports-section";
const industries = [{
  id: "logistics",
  label: "Logística",
  component: LogisticsSection
}, {
  id: "government",
  label: "Gobierno",
  component: GovernmentSection
}, {
  id: "manufacturing",
  label: "Manufactura",
  component: ManufacturingSection
}, {
  id: "sports",
  label: "Deporte",
  component: SportsSection
}, {
  id: "administration",
  label: "Administración",
  component: AdministrationSection
}, {
  id: "more",
  label: "¿Y Su Industria?",
  component: MoreIndustriesSection
}];
function IndustriesCarouselContent() {
  const $ = _c(11);
  const {
    api
  } = useCarousel();
  const [activeIndex, setActiveIndex] = React.useState(0);
  let t0;
  let t1;
  if ($[0] !== api) {
    t0 = () => {
      if (!api) {
        return;
      }
      const onSelect = () => {
        setActiveIndex(api.selectedScrollSnap());
      };
      api.on("select", onSelect);
      onSelect();
      return () => {
        api.off("select", onSelect);
      };
    };
    t1 = [api];
    $[0] = api;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  React.useEffect(t0, t1);
  let t2;
  if ($[3] !== activeIndex || $[4] !== api) {
    t2 = industries.map((industry, index) => <button key={industry.id} type="button" onClick={() => api?.scrollTo(index)} className={cn("shrink-0 px-3 sm:px-4 py-2 text-xs font-mono border border-transparent transition-all rounded-none", activeIndex === index ? "bg-primary text-primary-foreground border-primary" : "hover:bg-muted hover:text-background")}>{industry.label}</button>);
    $[3] = activeIndex;
    $[4] = api;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <nav className="absolute top-0 left-0 right-0 z-20 flex gap-1 p-3 sm:p-4 bg-background/80 backdrop-blur-sm border-b border-border overflow-x-auto overscroll-x-contain whitespace-nowrap [-webkit-overflow-scrolling:touch]">{t2}</nav>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CarouselContent className="pt-14 sm:pt-16">{industries.map(_temp)}</CarouselContent>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp(industry_0) {
  const Component = industry_0.component;
  return <CarouselItem key={industry_0.id} className="basis-full"><Component /></CarouselItem>;
}
export function IndustriesCarousel() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative w-full"><Carousel className="w-full" id="industrias" opts={{
        watchDrag: false
      }} plugins={[AutoHeight()]}><IndustriesCarouselContent /></Carousel></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}